
import { defineComponent, ref, watch } from 'vue';

export default defineComponent({
    name: "ErrorAlert",

    emits: ['close'],

    props: {
        message: {
            type: String,
            required: true
        },
    },

    mounted() {
        setTimeout(() => this.closeModal(), 5000);
    },

    setup(props: any, context: any) {
        function closeModal() {
            context.emit('close');
        }

        return { closeModal };
    },
});
